import ComponentWrapper from '../../fragments/component-wrapper/ComponentWrapper.jsx';
import ComponentHeading from '../../fragments/heading/ComponentHeading.jsx';

export default function SectionHeading({ block = {} }) {
  if (!block) return null;

  return (
    <ComponentWrapper className="SectionHeading" block={block}>
      <div className="l-grid">
        <ComponentHeading
          heading={block.heading}
          subheading={block.subheading}
          cta={block.cta}
        />
      </div>
    </ComponentWrapper>
  );
}
